import React, {ReactElement} from "react";
import {Navigate, Route} from "react-router-dom";
import CommissionsPage from "../../pages/chase/art/commissions/CommissionsPage";
import CommissionTosPage from "../../pages/chase/art/commissions/tos/CommissionTosPage";
import GalleriesPage from "../../pages/chase/art/galleries/GalleriesPage";
import FanArtGalleryPage from "../../pages/chase/art/galleries/fan-art/FanArtGalleryPage";
import CommissionGalleryPage from "../../pages/chase/art/galleries/commissions/CommissionGalleryPage";
import TelegramStickersPage from "../../pages/chase/art/telegram/TelegramStickersPage";
import ShopPage from "../../pages/chase/art/shop/ShopPage";

class ArtRouter {

    public static getRoutes(): ReactElement {
        return (
            <>
                <Route path="commissions">
                    <Route index element={<CommissionsPage/>}/>
                    <Route path="tos" element={<CommissionTosPage/>}/>
                </Route>
                <Route path="galleries">
                    <Route index element={<GalleriesPage/>}/>
                    <Route path="fan-art" element={<FanArtGalleryPage/>}/>
                    <Route path="commissions" element={<CommissionGalleryPage/>}/>
                </Route>
                <Route path="shop">
                    <Route index element={<ShopPage/>}/>
                </Route>
                <Route path="telegram-stickers">
                    <Route index element={<TelegramStickersPage/>}/>
                    <Route path="install" element={<Navigate replace to="https://t.me/addstickers/chasethefox"/>}/>
                </Route>
            </>
        );
    }
}

export default ArtRouter;